module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_02.ff73cca9.png";